import { defineStore } from "pinia";
import axios from "axios";
import Const from "@/const";
import { useAuthStore } from "@/stores/authStore";
const xsrfToken = document.cookie
    .split("; ")
    .find((row) => row.startsWith("XSRF-TOKEN="))
    ?.split("=")[1];
axios.defaults.baseURL = Const.URL;
const isLocalhost = window.location.hostname === "localhost";
let ApiUrl = `http://localhost:8080/api/`;
if (!isLocalhost) {
    ApiUrl = Const.URL;
}
export const useCasinoLiveStore = defineStore("casino-live", {
    state: () => ({
        games: [],
        liveGameCategories: [],
        page: 1,
        gameLiveCache: {},
    }),
    actions: {
        async fetchGames(page = 1, id = "all", key = "all") {
            if (this.games.length === 0 && this.gameLiveCache[id]) {
                this.games = Object.values(this.gameLiveCache[id]).flat();
            }
            if (this.gameLiveCache[id]?.[page]) {
                this.games = [...this.games];
                return;
            }
            try {
                let response;
                if (isLocalhost) {
                    let testConstUrl = `getCasinoGameTest.json`;
                    if (page === 2)
                        testConstUrl = `getCasinoGameTest.json`;
                    else if (page === 3)
                        testConstUrl = `getCasinoGameTest.json`;
                    const apiPath = `${ApiUrl}/${testConstUrl}`;
                    response = await axios.get(apiPath, {
                        headers: { "Accept": "application/json" },
                        timeout: 100000,
                        withCredentials: true,
                    });
                }
                else {
                    response = await axios.post(`${Const.URL}/get_games_by_providers`, {
                        providerID: id,
                        page,
                        gametype: "LiveGames",
                    }, {
                        headers: { "Accept": "application/json" },
                        timeout: 100000,
                        withCredentials: true,
                    });
                }
                if (!this.gameLiveCache[id]) {
                    this.gameLiveCache[id] = {};
                }
                if (!this.gameLiveCache[id][page]) {
                    this.gameLiveCache[id][page] = response.data.availableGames.games;
                }
                const newGames = response.data.availableGames.games.filter(game => !this.games.some(existingGame => existingGame.id === game.id));
                this.games = [...this.games, ...newGames];
            }
            catch (error) {
                console.error("Error fetching games:", error.message);
            }
        },
        async fetchGameCategories() {
            try {
                let response;
                if (isLocalhost) {
                    const testConstUrl = `http://localhost:8080/api`;
                    response = await axios.get(`${testConstUrl}/get_all_providers.json`, {
                        headers: { "Accept": "application/json" },
                        timeout: 10000,
                        withCredentials: true,
                    });
                }
                else {
                    response = await axios.get(`${Const.URL}/get_all_providers`, {
                        headers: { "Accept": "application/json" },
                        timeout: 10000,
                        withCredentials: true,
                    });
                }
                this.liveGameCategories = response.data.data.filter(category => !["Gold Slots", "Soft Gaming", "Fortune Panda"].includes(category.name));
            }
            catch (error) {
                console.error("Error fetching game categories:", error.message);
            }
        },
        async fetchGameDetails(url, id = "all") {
            const authStore = useAuthStore();
            if (isLocalhost) {
                authStore.setGame("https://tables.freshdeckstudios.com/activation/fallback-url");
            }
            else {
                const liveremoteid = "1737536028598";
                try {
                    const response = await axios.post(`${Const.URL}/get_game_details`, {
                        gameid: id,
                        url,
                        remoteId: liveremoteid,
                    }, {
                        headers: { "Accept": "application/json" },
                        timeout: 100000,
                        withCredentials: true,
                    });
                    if (response.data) {
                        authStore.setGame(response.data.result);
                    }
                    else {
                        console.error("No data found in the response.");
                    }
                }
                catch (error) {
                    console.error("Error fetching game details:", error.message);
                }
            }
        },
        incrementPage() {
            this.page++;
        },
        clearGames() {
            this.games = [];
            this.page = 1;
        }
    },
});
